/**
 * PlaceholderPage.tsx — Coming soon placeholder for unimplemented pages
 *
 * P1 note: the slate-stray `legacy-*` palette this page carried was remapped
 * to canonical tokens at GATE 2 (ink/edge/surface families) and the legacy
 * namespace deleted, per the Phase-0 contract. Sizes sit on the P1 scale.
 */
import { Construction } from 'lucide-react'

interface PlaceholderPageProps {
  title: string
  description?: string
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <div className="page-enter flex flex-col gap-5">
      <div>
        <h1 className="text-section-title font-semibold text-ink-primary leading-tight">{title}</h1>
        {description && <p className="text-13 text-ink-secondary mt-1">{description}</p>}
      </div>
      <div className="flex flex-col items-center justify-center py-24 bg-surface-card rounded-card border border-edge-card">
        <div className="w-12 h-12 rounded-control bg-surface-panel flex items-center justify-center mb-4">
          <Construction size={22} className="text-ink-faint" />
        </div>
        <div className="text-16 font-semibold text-ink-primary mb-1">Coming soon</div>
        <p className="text-13 text-ink-muted text-center max-w-xs">
          This section is part of the implementation plan and will be built after the prototype is approved.
        </p>
      </div>
    </div>
  )
}
